import React from "react";
import {
  createUpdateClientType,
  getClientTypes,
} from "../../helpers/backend_helper";
import MasterList from "./MasterList";

const ClientType = ({ createRequest = 0, tourRequest = 0 }) => (
  <MasterList
    createRequest={createRequest}
    tourRequest={tourRequest}
    label="Client Type"
    pluralLabel="Client Types"
    listMasters={() => getClientTypes(true)}
    createMaster={createUpdateClientType}
    fileName="client-types"
  />
);

export default ClientType;
